module.exports = __webpack_public_path__ + "static/media/betson-screenshot-3.f9d586fd.png";